import {Injectable} from '@angular/core';
import {HttpService} from '../http/http.service';
import {catchError, map, Observable} from 'rxjs';
import {iResponseList} from '../../models/response/response.model';
import {GenderModel} from '../../models/gender/gender.model';

@Injectable({
    providedIn: 'root'
})
export class GenderService extends HttpService {

    getGenders(): Observable<iResponseList<GenderModel>> {
        return this.get('genders').pipe(
            map((response: iResponseList<GenderModel>) => {
                return response;
            }),
            catchError(error => {
                throw error
            })
        )
    }
}
